module.exports = __webpack_public_path__ + "images/external_images/img/500x450/img12.jpg";